/* 🤖 this file was generated by svg-to-ts */
export var spxIconCheckCircleOutline = {
    name: 'check_circle_outline',
    data: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"42\" viewBox=\"0 0 42 42\" fill=\"none\"><path d=\"M41 21C41 9.9543 32.0457 1 21 1C9.9543 1 1 9.9543 1 21C1 32.0457 9.9543 41 21 41C32.0457 41 41 32.0457 41 21Z\" stroke-width=\"2\"/><path d=\"M13 22.5C13 22.5 16.2 24.3251 17.8 27C17.8 27 22.6 16.5 29 13\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>"
};
